import { UntypedFormBuilder } from '@angular/forms';
import { isPlatformBrowser, Location } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FeatureProvider, getCurrentLanguage, State as storeState, UserInfoService, UtilityService } from '@ecap3/core';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';
import { IDmsConfig } from '../../interface/document.manager.interface';
import { DriveFile } from '../../models/DriveFile';
import { DriveFolder } from '../../models/DriveFolder';
import { DriveUploadQueue } from '../../models/DriveUploadQueue';
import { DocumentManagerService } from '../../services/document-manager.service';
import { DocumentUploadBottomSheetComponent } from '../document-upload-bottom-sheet/document-upload-bottom-sheet.component';
import { DocumentUploadQueueComponent } from '../document-upload-queue/document-upload-queue.component';
import { take } from 'rxjs/operators';
import { DocumentFeaturesForModule, ModuleDMSConfig } from 'src/app/delta-config/constant/module-dms.constant';
import { CommonService } from 'src/app/shared/services/common.service';
import { DeltaBusinessService } from 'src/app/shared/services/delta-business.service';
import { ZipDownloadService } from 'src/app/shared/services/zip-download.service';
import { OrganizationDocuments } from '../../../app-organizational-documents/interface/organization-documents.interface';
import { OrganizationalDocumentType } from '../../../app-organizational-documents/enums/organiztional-documents.enum';
import { DocumentService } from '../../services/document.service';
import { Store } from '@ngrx/store';
import { Observable, Subject, Subscription, firstValueFrom } from 'rxjs';
import { deepSafeAccess } from 'src/app/shared/helpers/deep-safe-access';

@Component({
    selector: 'app-document-list',
    templateUrl: './document-list.component.html',
    styleUrls: ['./document-list.component.scss']
})
export class DocumentListComponent implements OnInit, OnDestroy {
    @ViewChild('Sidenav', { static: true }) public Sidenav: MatSidenav;
    @Input() appearance = 'outline';
    @Input() dmsConfig: IDmsConfig;
    lang$: Observable<string>;
    langSub: Subscription;
    public _unsubscribeAll: Subject<any> = new Subject();
    public SelectedDocuments: any[] = [];
    public bottomSheetRef;
    public State: State = {
        IsLoading: true,
        SelectedItemIds: [],
        ViewMode: 'List', // 'Gallery' / 'Grid'
        IsDraggingOver: false,
        IsBottomSheetOpen: false,
        IsParentSecure: false
    };
    folderChange = false;
    private subscription: Subscription[] = [];

    public MyDrive: MyDrive = {
        Folders: [],
        Files: [],
        UploadQueue: []
    };
    public Breadcrumbs: DriveFolder[] = [
        {
            Name: 'MY_DOCUMENTS',
            ItemId: ''
        } as DriveFolder
    ];
    changesUrl = false;
    newProjectId: string;
    public CurrentFolderId = null;
    isPlatformBrowser: boolean;
    public createFileAndFolderPermission = true;
    UserId: any;
    public overArea;
    public dropMask;
    private FileRemoveSubscription: Subscription;
    private FolderSubscription: Subscription;
    private WorkingSubscription: Subscription;
    private folderFlat: any = [];
    private maxFileSize = 10000000; //10MB
    private Helper = {
        ProcessUploadQueue: (files) => {
            const tempQ = cloneDeep(this.MyDrive.UploadQueue);
            const processedFiles = [];
            if (Array.isArray(files)) {
                // Via File Browser
                files.forEach((file) => {
                    const ext = file.name.split('.').pop();
                    if (!('ItemId' in file)) {
                        file['ItemId'] = this.utilityService.getNewGuid();
                    }
                    if (file.size > this.maxFileSize) {
                        const queueItem = new DriveUploadQueue(
                            file['ItemId'],
                            this.translateService.instant(
                                'APP_PLATFORM_DOCUMENT_MANAGER.DMS_MAX_FILE_SIZE_ERROR'
                            ),
                            -1
                        );
                        tempQ.push(queueItem);
                    } else if (ext === 'exe') {
                        const queueItem = new DriveUploadQueue(
                            file['ItemId'],
                            this.translateService.instant(
                                'APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN'
                            ),
                            -1
                        );
                        tempQ.push(queueItem);
                    } else {
                        const queueItem = new DriveUploadQueue(
                            file['ItemId'],
                            file['name'],
                            0
                        );
                        processedFiles.push(file);
                        tempQ.push(queueItem);
                    }
                });
            } else {
                // File Dropped
                Object.keys(files).forEach((key) => {
                    const file = files[key];
                    const ext = file.name.split('.').pop();
                    file['ItemId'] = this.utilityService.getNewGuid();
                    if (file.size > this.maxFileSize) {
                        const queueItem = new DriveUploadQueue(
                            file['ItemId'],
                            this.translateService.instant(
                                'APP_PLATFORM_DOCUMENT_MANAGER.DMS_MAX_FILE_SIZE_ERROR'
                            ),
                            -1
                        );
                        tempQ.push(queueItem);
                    } else if (ext === 'exe') {
                        const queueItem = new DriveUploadQueue(
                            file['ItemId'],
                            this.translateService.instant(
                                'APP_PLATFORM_DOCUMENT_MANAGER.DMS_EXE_FILE_ERROR'
                            ),
                            -1
                        );
                        tempQ.push(queueItem);
                    } else {
                        const queueItem = new DriveUploadQueue(
                            file['ItemId'],
                            file['name'],
                            0
                        );
                        processedFiles.push(file);
                        tempQ.push(queueItem);
                    }
                });
            }
            this.MyDrive.UploadQueue = tempQ;
            this.Actions.OpenUploadQueue(this.MyDrive.UploadQueue);
            return processedFiles;
        }
    };
    public Actions = {
        OpenSideNav: () => {
            this.Sidenav.close();
        },
        CloseSideNav: () => {
            this.Sidenav.close();
        },
        Select: ($event) => {
            const idx = this.SelectedDocuments.indexOf($event);
            if (idx == -1) {
                this.SelectedDocuments.push($event);
            } else {
                this.SelectedDocuments.splice(idx, 1);
            }
            if ($event == '') this.SelectedDocuments = [];
            this.State.SelectedItemIds = this.SelectedDocuments.map(
                (item) => item.ItemId
            );
            this._DocumentManagerService.onShowDetail.next($event);
        },
        DragOver: ($event) => {
            $event.stopPropagation();
            $event.preventDefault();
            if (!this.dmsConfig.viewMyDoc) return;
            this.dropMask.style.display = 'block';
            this.State.IsDraggingOver = true;
            this.Actions.OpenBottomSheet();
        },
        Drop: ($event) => {
            $event.stopPropagation();
            $event.preventDefault();
            if (!this.dmsConfig.viewMyDoc) return;
            if (this.State.IsBottomSheetOpen) {
                this.bottomSheetRef.dismiss();
                this.State.IsBottomSheetOpen = false;
            }
            this.State.IsDraggingOver = false;
            this.dropMask.style.display = 'none';
            let files = $event.dataTransfer.files; // Array of all files
            if (files.length > 0) {
                if (files.length > 20) {
                    this.matSnackBarOpen(
                        this.translateService.instant(
                            'APP_PLATFORM_DOCUMENT_MANAGER.DMS_MAX_FILE_LIMIT_ERROR'
                        )
                    );
                } else {
                    this.CurrentFolderId = this.getCorrectFolderId();
                    let parentId = this.CurrentFolderId;
                    if (!parentId) parentId = this.dmsConfig.ParentFolderId;
                    files = this.Helper.ProcessUploadQueue(files);
                    this._DocumentManagerService
                        .UploadAllFiles(
                            files,
                            parentId,
                            this.dmsConfig.OrganizationId,
                            this.dmsConfig.UseLicensing,
                            this.dmsConfig.ModuleWorkspaceId
                        )
                        .then(
                            (uploadResp) => {
                                uploadResp.result.forEach((res) => {
                                    const i =
                                        this.MyDrive.UploadQueue.findIndex(
                                            (x) => x.ItemId === res.ItemId
                                        );
                                    if (i > -1) {
                                        this.MyDrive.UploadQueue[i].Percentage =
                                            res.uploadPercentage;
                                    }
                                });
                                const j = this.MyDrive.UploadQueue.findIndex(
                                    (x) => x.Percentage < 100
                                );
                                if (j > -1) {
                                    this.MyDrive.UploadQueue[
                                        j
                                    ].Percentage = 100;
                                }
                                this.init();
                            },
                            (error) => {
                                console.log(error);
                                this.matSnackBarOpen(
                                    this.translateService.instant(
                                        'APP_PLATFORM_DOCUMENT_MANAGER.DMS_ERROR_UPLOADING_FILE'
                                    )
                                );
                            }
                        );
                }
            }
        },
        DragLeave: ($event) => {
            $event.stopPropagation();
            $event.preventDefault();
            if (!this.dmsConfig.viewMyDoc) return;
            this.dropMask.style.display = 'none';
            this.State.IsDraggingOver = false;
            if (this.State.IsBottomSheetOpen) {
                this.bottomSheetRef.dismiss();
                this.State.IsBottomSheetOpen = false;
            }
        },
        OpenBottomSheet: () => {
            if (!this.State.IsBottomSheetOpen) {
                const config: MatBottomSheetConfig = {
                    hasBackdrop: false,
                    disableClose: false,
                    panelClass: 'bottom-sheet-panel'
                };
                this.bottomSheetRef = this.bottomSheet.open(
                    DocumentUploadBottomSheetComponent,
                    config
                );
                this.State.IsBottomSheetOpen = true;
            }
        },
        OpenUploadQueue: (Files) => {
            const config: MatBottomSheetConfig = {
                hasBackdrop: false,
                disableClose: false,
                panelClass: 'upload-queue-bottom-sheet-panel',
                data: Files
            };
            this.bottomSheetRef = this.bottomSheet.open(
                DocumentUploadQueueComponent,
                config
            );
            firstValueFrom(this.bottomSheetRef
                .afterDismissed())
                .then((resp) => {
                    console.log(resp);
                    this.MyDrive.UploadQueue = [];
                });
        },
        UploadByBrowsing: (Files) => {
            const fileInputElement: any = document.querySelector('input#FileBrowser');
            const parentId = this.getParentIdForUpload();

            if (Files.length > 0) {
                if (Files.length > 20) {
                    this.showMaxFileLimitError();
                } else {
                    Files = this.Helper.ProcessUploadQueue(Files);
                    this.uploadFiles(Files, parentId).then(
                        (uploadResp) => this.handleUploadSuccess(uploadResp, parentId, fileInputElement),
                        (error) => {
                            console.log(error);
                            this.showUploadError()
                        }
                    );
                }
            }
        },
        ChangeFolder: (ParentId: string) => {
            this.State.IsLoading = true;

            if (this.dmsConfig.useCustomApi) {
                this.loadOrganizationalDocuments(ParentId);
            } else {
                this.handleStandardApi(ParentId);
            }
        },
        BreadcrumbClick: (ParentId, index) => {
            this.ignoreSerchText = true;
            this.searchKey = '';
            if (index === 0) {
                if (this.dmsConfig && this.dmsConfig.ParentFolderId) {
                    ParentId = this.dmsConfig.ParentFolderId;
                    this.location.go(
                        this.dmsConfig.rootRoute +
                            'folder/' +
                            this.dmsConfig.ParentFolderId +
                            '/'
                    );
                } else {
                    this.location.go(this.dmsConfig.rootRoute);
                }
                localStorage.removeItem(
                    this.dmsConfig && this.dmsConfig.BreadcrumbName
                );
                this.Breadcrumbs = [
                    this.dmsConfig.initialBreadcumb as DriveFolder
                ];

                // this.folderTree = [{
                //     'Name': 'APP_PLATFORM_DOCUMENT_MANAGER.DMS_MY_DOCUMENTS',
                //     'ItemId': '',
                //     'child': []
                // }];
                // localStorage.removeItem(this.dmsConfig&&this.dmsConfig.BreadcrumbName);
            } else {
                this.Breadcrumbs = this.Breadcrumbs.slice(0, index + 1);
                // this.removeFromFolderTree(index);
            }

            this.Actions.ChangeFolder(ParentId);
            if (this.isPlatformBrowser) {
                localStorage.setItem(
                    this.dmsConfig && this.dmsConfig.BreadcrumbName,
                    JSON.stringify(this.Breadcrumbs)
                );
            }
        }
    };

    constructor(
        private commonService: CommonService,
        private activeRoute: ActivatedRoute,
        public userInfoService: UserInfoService,
        public location: Location,
        public snackBar: MatSnackBar,
        private router: Router,
        private _DocumentManagerService: DocumentManagerService,
        private customDocumentManagerService: DocumentService,
        private bottomSheet: MatBottomSheet,
        public dialog: MatDialog,
        public zipDownloadService: ZipDownloadService,
        private route: ActivatedRoute,
        private translateService: TranslateService,
        private activatedRoute: ActivatedRoute,
        private utilityService: UtilityService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private readonly fb: UntypedFormBuilder,
        private deltaBusinessService: DeltaBusinessService,
        private featureProvider: FeatureProvider,
        private store: Store<storeState>,
    ) {
        this.lang$ = this.store.select(getCurrentLanguage);
        this._unsubscribeAll = new Subject();
        localStorage.clear();
        this.subscription.push(
            this.commonService.navigationChange.subscribe({
                next: (projectId) => {
                    this.newProjectId = projectId;
                    this.changesUrl = !this.changesUrl;
                }
            })
        );
        this.isPlatformBrowser = isPlatformBrowser(this.platformId);
        this.router.events.subscribe({
            next: (event) => {
                if (event.constructor.name === 'NavigationStart') {
                    if (this.bottomSheetRef) {
                        this.bottomSheetRef.dismiss();
                    }
                }
            }
        });
        
        this.FolderSubscription =
            this._DocumentManagerService.FolderEvent.subscribe({
                next: (Folder) => {
                    if (Folder) {
                        this.handleFolder(Folder);
                    } else if (this.isPlatformBrowser) {
                        const dmsBread =
                            JSON.parse(
                                localStorage.getItem(
                                    this.dmsConfig && this.dmsConfig.BreadcrumbName
                                )
                            ) || [];
                        if (dmsBread.length > 0) {
                            this.Breadcrumbs = dmsBread;
                        }
                    }
                }
            });

        this.FileRemoveSubscription =
            this._DocumentManagerService.onFileRemove.subscribe({
                next: (Remove) => {
                    if (Remove) {
                        this.init();
                    }
                }
            });

        this.WorkingSubscription =
            this._DocumentManagerService.workingState.subscribe({
                next: (workingState) => {
                    if (workingState === 'busy') {
                        this.State.IsLoading = true;
                    } else if (workingState === 'idle') {
                        this.State.IsLoading = false;
                    }
                }
            });
    }

    private handleFolder(folder): void {
        this.searchKey = '';

        if (Array.isArray(folder)) {
            this.handleFolderList(folder);
        } else {
            this.handleSingleFolder(folder);
        }

        this.CurrentFolderId = this.getCorrectFolderId();
        if (!this.CurrentFolderId && folder)
            this.CurrentFolderId = folder.ItemId;
        this.Actions.ChangeFolder(this.CurrentFolderId);
    }

    private handleFolderList(folder): void {
        this.Breadcrumbs = [...folder];
        if (this.isPlatformBrowser) {
            localStorage.removeItem(
                this.dmsConfig && this.dmsConfig.BreadcrumbName
            );
            localStorage.setItem(
                this.dmsConfig && this.dmsConfig.BreadcrumbName,
                JSON.stringify(this.Breadcrumbs)
            );
        }
    }

    private handleSingleFolder(folder): void {
        this.createFileAndFolderPermission = !(folder.Type && folder.Type === 'SharedFolder');

        this.Breadcrumbs.push(folder);

        if (this.isPlatformBrowser) {
            localStorage.setItem(
                this.dmsConfig && this.dmsConfig.BreadcrumbName,
                JSON.stringify(this.Breadcrumbs)
            );
        }
    }

    getCurrentParentSecurity() {
        return new Promise((resolve) => {
            this._DocumentManagerService
                .GetObjectArtifactById(
                    this.Breadcrumbs[this.Breadcrumbs.length - 1]
                )
                .then((res) => {
                    this.State.IsParentSecure = !!(
                        res &&
                        res[0] &&
                        res[0].Secured
                    );
                    resolve(this.State.IsParentSecure);
                });
        });
    }

    private loadOrganizationalDocuments(ParentId: string): void {
        const filter = this.createDocumentFilter(ParentId);

        this.customDocumentManagerService.getOrganizationalDocuments(filter).subscribe({
            next: (res) => this.processOrganizationalDocuments(res),
            error: (error) => this.handleLoadError(error)
        });
    }

    private createDocumentFilter(ParentId: string) {
        return {
            IsPublished: true,
            IsArchived: false,
            DocumentId: '',
            ParentId: ParentId || '',
            SearchKey: this.searchKey,
            SearchAllSubFolders: false
        };
    }

    private processOrganizationalDocuments(res: any): void {
        const [driveFiles, driveFolders] = this.generateMyDriveFilesAndFoldersFromOrganizationalDocuments(res);
        this.State.IsLoading = false;
        this.MyDrive.Folders = this.fileNameSort(driveFolders);
        this.MyDrive.Files = this.fileNameSort(driveFiles);
    }

    private handleLoadError(error: any): void {
        console.log(error);
        this.State.IsLoading = false;
        this.matSnackBarOpen('Something went wrong', 1500);
    }

    private handleStandardApi(ParentId: string): void {
        this.getCurrentParentSecurity().then(() => {
            this.loadDocuments(ParentId);
        });
    }

    private loadDocuments(ParentId: string): void {
        this._DocumentManagerService.GetAllDocumentsNew(
            ParentId,
            this.dmsConfig.ModuleWorkspaceId,
            this.searchKey,
            this.dmsConfig.viewArchivedDoc
        ).then(
            (documents) => this.processLoadedDocuments(documents, ParentId),
            (error) => this.handleDocumentLoadError(error)
        );
    }

    private processLoadedDocuments(documents: any, ParentId: string): void {
        this.updateFolderTypes(documents['Folders']);
        this.ignoreSerchText = false;

        if (ParentId) {
            this.location.go(this.dmsConfig.rootRoute + 'folder/' + ParentId + '/');
        }

        this.folderChange = !this.folderChange;
        this.CurrentFolderId = ParentId;
        this.State.IsLoading = false;

        if(this.dmsConfig.BreadcrumbName === "Project_Files"){
            documents['Folders'] = documents['Folders'].filter(folder => folder.Description === "ForEmployee");
        }
        this.MyDrive.Folders = this.fileNameSort(documents['Folders']);
        this.MyDrive.Files = this.fileNameSort(documents['Files']);
        this.fetchAndFilterFeatures();
    }

    private updateFolderTypes(folders: any[]): void {
        for (const folder of folders) {
            if (ModuleDMSConfig.forbiddenIdsToDelete.includes(folder.ItemId)) {
                folder.Type = 'SharedFolder';
            }
        }
    }

    private handleDocumentLoadError(error: any): void {
        console.log(error);
        this.State.IsLoading = false;
    }

    private fetchAndFilterFeatures(): void {
        this.featureProvider.getFeatures().then((features: any[]) => {
            this.filterDriveFolders(features);
            this._DocumentManagerService.onTableViewChange.next({ Change: true });
        });
    }

    private filterDriveFolders(features: any[]): void {
        const crmView = this.findFeature(features, DocumentFeaturesForModule.CRM);
        const hrView = this.findFeature(features, DocumentFeaturesForModule.HR);
        const projectView = this.findFeature(features, DocumentFeaturesForModule.Projects);

        this.MyDrive.Folders = this.MyDrive.Folders.filter(item => {
            return this.isFolderAccessible(item, crmView, hrView, projectView);
        });
    }

    private findFeature(features: any[], module: any): any {
        return features.find(feature => {
            return feature.Name === module.AppName && feature.Features.includes(module.FeatureId);
        });
    }

    private isFolderAccessible(item: any, crmView: any, hrView: any, projectView: any): boolean {
        if (item.ItemId === ModuleDMSConfig.CRMFolderId && !crmView) {
            return this.hasAccess(item);
        }
        if (item.ItemId === ModuleDMSConfig.DirectoryFolderId && !hrView) {
            return this.hasAccess(item);
        }
        if (item.ItemId === ModuleDMSConfig.ProjectFolderId && !projectView) {
            return this.hasAccess(item);
        }
        return true;
    }

    private hasAccess(item: any): boolean {
        return (
            item.SharedUserIdList.includes(this._DocumentManagerService.loggedIuUser.UserId) ||
            this._DocumentManagerService.loggedIuUser.Roles.includes('admin') ||
            this._DocumentManagerService.loggedIuUser.Roles.some(role => item.SharedRoleList.includes(role))
        );
    }


    private getParentIdForUpload(): string {
        this.CurrentFolderId = this.getCorrectFolderId();
        return this.CurrentFolderId || this.dmsConfig.ParentFolderId;
    }

    private showMaxFileLimitError(): void {
        this.matSnackBarOpen(
            this.translateService.instant('APP_PLATFORM_DOCUMENT_MANAGER.DMS_MAX_FILE_LIMIT_ERROR')
        );
    }

    private showUploadError(): void {
        this.matSnackBarOpen(
            this.translateService.instant('APP_PLATFORM_DOCUMENT_MANAGER.DMS_ERROR_UPLOADING_FILE')
        );
    }

    private uploadFiles(Files: any[], parentId: string): Promise<any> {
        return this._DocumentManagerService.UploadAllFiles(
            Files,
            parentId,
            this.dmsConfig.OrganizationId,
            this.dmsConfig.UseLicensing,
            this.dmsConfig.ModuleWorkspaceId
        );
    }

    private handleUploadSuccess(uploadResp: any, parentId: string, fileInputElement: HTMLInputElement): void {
        this.MyDrive.UploadQueue.forEach((queue) => (queue.Percentage = 100));
        fileInputElement.value = null;

        if (parentId && this.dmsConfig.moduleFeatureId && uploadResp.result.length > 0) {
            this.handleArtifactMapping(parentId, uploadResp);
        } else if (JSON.stringify(this.dmsConfig.updateAccessRoles) !== '{}' && !this.dmsConfig.moduleFeatureId) {
            this.handleAccessRoleMapping(uploadResp);
        } else {
            this.init();
        }
    }

    private handleArtifactMapping(parentId: string, uploadResp: any): void {
        this._DocumentManagerService.GetObjectArtifactById(parentId).then((artifactResp) => {
            this.deltaBusinessService
                .mapObjectArtifactBulk({
                    ArtifactIds: uploadResp.result.map((item) => item.ItemId),
                    CorrespondingFeatureId: this.dmsConfig.moduleFeatureId,
                    ...this.dmsConfig.updateAccessRoles,
                    CleanAccessibilityLists: this.shouldCleanAccessibilityLists(artifactResp)
                })
                .pipe(take(1))
                .subscribe({
                    next: (mapResp) => {
                        console.log(mapResp);
                        if (this.dmsConfig.shareToUserIds && this.dmsConfig.shareToUserIds.length > 0) {
                            this.shareUploadedArtifacts(uploadResp);
                        } else {
                            this.init();
                        }
                    }
                });
        });
    }

    private shouldCleanAccessibilityLists(artifactResp: any): boolean {
        return !!deepSafeAccess(artifactResp, ['0', 'OrganizationId']);
    }

    private handleAccessRoleMapping(uploadResp: any): void {
        this.deltaBusinessService
            .mapObjectArtifactBulk({
                ArtifactIds: uploadResp.result.map((item) => item.ItemId),
                CorrespondingFeatureId: 'not-available-feature',
                ...this.dmsConfig.updateAccessRoles,
                CleanAccessibilityLists: true
            })
            .pipe(take(1))
            .subscribe(() => {
                this.init();
            });
    }

    private shareUploadedArtifacts(uploadResp: any): void {
        const artifactIds = uploadResp.result.map((item) => item.ItemId);

        artifactIds.forEach((artifactId) => {
            this.deltaBusinessService
                .shareObjectInDeltaWay({
                    ArtifactId: artifactId,
                    UserIds: this.dmsConfig.shareToUserIds,
                    RoleNames: []
                })
                .pipe(take(1))
                .subscribe(() => {
                    this.init();
                });
        });
    }

    getCorrectFolderId() {
        if (this.isPlatformBrowser) {
            const dmsBread =
                JSON.parse(
                    localStorage.getItem(
                        this.dmsConfig && this.dmsConfig.BreadcrumbName
                    )
                ) || [];
            if (dmsBread.length > 0) {
                if (dmsBread[dmsBread.length - 1].Type === 'SharedFolder') {
                    if (this.dmsConfig.ModuleWorkspaceId)
                        return dmsBread[dmsBread.length - 1].ItemId;
                    return dmsBread[dmsBread.length - 1]
                        .OriginalObjectArtifactId;
                } else if (
                    dmsBread[dmsBread.length - 1].Type === 'DriveFolder'
                ) {
                    return dmsBread[dmsBread.length - 1].ItemId;
                }
            } else {
                return this.dmsConfig.ParentFolderId;
            }
        }
    }

    /**
     * @description converts an array organizational documents into a tuple of DriveFiles and DriveFolders
     * @returns returns a tuple of DriveFiles and DriveFolders
     * @param documents
     */
    generateMyDriveFilesAndFoldersFromOrganizationalDocuments(
        documents: OrganizationDocuments[]
    ): [DriveFile[], DriveFolder[]] {
        const DriveFiles: DriveFile[] = documents
            .filter(
                (document) => document.Type === OrganizationalDocumentType.FILE
            )
            .map((doc) => {
                return new DriveFile(
                    doc.ParentId,
                    false,
                    '',
                    '',
                    '',
                    doc.OwnerUserId,
                    doc.ItemId,
                    '',
                    doc.Name,
                    doc.Description,
                    '',
                    '',
                    doc.FileId,
                    '',
                    doc.FileSizeInByte / 1024,
                    'DriveFile',
                    doc.Url,
                    doc.PublishedOn,
                );
            });
        const DriveFolders: DriveFolder[] = documents
            .filter(
                (document) =>
                    document.Type === OrganizationalDocumentType.FOLDER
            )
            .map((doc) => {
                return new DriveFolder(
                    doc.ParentId,
                    false,
                    '',
                    '',
                    '',
                    doc.OwnerUserId,
                    '',
                    doc.ItemId,
                    doc.Name,
                    '',
                    null,
                    '',
                    [],
                    [],
                    '',
                    'DriveFolder',
                    doc.IsPublished,
                    doc.IsArchived
                );
            });
        return [DriveFiles, DriveFolders];
    }
    init() {
        if (!this.dmsConfig) return;
        this.State.IsLoading = true;
        if (!this._DocumentManagerService.loggedIuUser) {
            this.userInfoService.getLoggedInUser().subscribe({
                next: (user) => {
                    this._DocumentManagerService.loggedIuUser = user;
                }
            });
        }
        this.CurrentFolderId = this.getCorrectFolderId();
        let currentId = this.CurrentFolderId;
        if (!currentId) currentId = this.dmsConfig.ParentFolderId;
        if (this.dmsConfig.useCustomApi) {
            const filter = {
                IsPublished: true,
                IsArchived: false,
                DocumentId: '',
                ParentId: currentId || '',
                SearchKey: this.searchKey,
                SearchAllSubFolders: false
            };
            this.customDocumentManagerService
                .getOrganizationalDocuments(filter)
                .subscribe({
                    next: (res) => {
                        const [driveFiles, driveFolders] =
                            this.generateMyDriveFilesAndFoldersFromOrganizationalDocuments(
                                res
                            );
                        this.State.IsLoading = false;
                        this.MyDrive.Folders = this.fileNameSort(driveFolders);
                        this.MyDrive.Files = this.fileNameSort(driveFiles);
                    },
                    error: () => {
                        this.State.IsLoading = false;
                        this.matSnackBarOpen('Something went wrong', 1500);
                    }
                });
            return;
        }
        this._DocumentManagerService
            .GetAllDocumentsNew(
                currentId,
                this.dmsConfig.ModuleWorkspaceId,
                this.searchKey,
                this.dmsConfig.viewArchivedDoc
            )
            .then(
                (documents) => {
                    console.log(document, "ONE");
                    for (const folder of documents['Folders']) {
                        if (
                            ModuleDMSConfig.forbiddenIdsToDelete.includes(
                                folder.ItemId
                            )
                        ) {
                            folder.Type = 'SharedFolder';
                        }
                    }
                    if(this.dmsConfig.BreadcrumbName === "Project_Files"){
                        documents['Folders'] = documents['Folders'].filter(folder => folder.Description === "ForEmployee");
                    }
                    this.State.IsLoading = false;
                    this.MyDrive.Folders = this.fileNameSort(
                        documents['Folders']
                    );
                    this.MyDrive.Files = this.fileNameSort(documents['Files']);
                },
                (error) => {
                    console.log(error);
                    this.State.IsLoading = false;
                    this.matSnackBarOpen('Something went wrong', 1500);
                }
            );
    }

    fileNameSort(arr) {
        arr.sort((a, b) => {
            const x = a['Name'].toLowerCase();
            const y = b['Name'].toLowerCase();
            if (x < y) {
                return -1;
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
        return arr;
    }
    addDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    deleteDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    downloadDocFeature = [
        {
            AppName: 'DMS',
            FeatureId: 'dms'
        }
    ];
    async ngOnInit() {
        this.langSub = this.lang$.subscribe({
            next: (lang) => {
                this.translateService.use(lang);
            }
        });
        this.State.IsLoading = true;
        this._DocumentManagerService.loggedIuUser = await firstValueFrom(this.userInfoService
            .getLoggedInUser());
        if (this.dmsConfig && this.dmsConfig.moduleFeatureId) {
            this.addDocFeature = this.dmsConfig.features.addDoc;
            this.deleteDocFeature = this.dmsConfig.features.deleteDoc;
            this.downloadDocFeature = [
                ...this.dmsConfig.features.addDoc,
                ...this.dmsConfig.features.deleteDoc,
                ...this.dmsConfig.features.shareDoc
            ];
        } else if(!deepSafeAccess(this.dmsConfig, ['useCustomApi'])) {
            this.State.IsLoading = false;
            return;
        }
        this.subscription.push(
            this.activeRoute.params.subscribe({
                next: (params) => {
                    this.dmsConfig.OrganizationId = params.projectId;
                }
            })
        );
        if (this.dmsConfig.viewConfig && this.dmsConfig.viewConfig.listView) {
            this.State.ViewMode = 'Grid';
        }
        this.State.DownloadSecureFile = this.dmsConfig.downloadSecureFile;
        this.overArea = document.getElementById('box');
        this.dropMask = document.getElementById('drop-mask');
        this.createFileAndFolderPermission = true;
        this.activatedRoute.params.subscribe({
            next: (params: Params) => {
                if (this.isPlatformBrowser) {
                    const folder = JSON.parse(
                        localStorage.getItem(
                            this.dmsConfig && this.dmsConfig.BreadcrumbName
                        )
                    ) || [this.dmsConfig.initialBreadcumb as DriveFolder];
    
                    this.Breadcrumbs = folder;
                    if (folder[1] && folder[1].Type === 'SharedFolder') {
                        this.createFileAndFolderPermission = false;
                    }
                }
                if (params['id']) {
                    this.CurrentFolderId = params['id'];
                    this.init();
                } else {
                    this.init();
                }
            }
        });
        if (window.screen.width > 720) {
            this.Actions.OpenSideNav();
        }
        if (this.dmsConfig.hideSideNav) {
            this.Actions.CloseSideNav();
        }
        if (this.dmsConfig && this.dmsConfig.maxFileSize) {
            this.maxFileSize = this.dmsConfig.maxFileSize;
        }
        this.userInfoService.currentUser.subscribe({
            next: (result: any) => {
                if (result.UserId || result.PersonId) {
                    this.UserId = result.UserId;
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.bottomSheetRef) {
            this.bottomSheetRef.dismiss();
        }
        this.FolderSubscription.unsubscribe();
        this.FileRemoveSubscription.unsubscribe();
        this.WorkingSubscription.unsubscribe();
        if (this.isPlatformBrowser) {
            localStorage.removeItem(
                this.dmsConfig && this.dmsConfig.BreadcrumbName
            );
        }
    }


    matSnackBarOpen(value, duration?: number) {
        const translateValue = this.translateService.instant(value);
        this.snackBar.open(translateValue, null, {
            duration: duration || 3000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: 'custom-snackbar'
        });
    }
    async download() {
        const folders = this.SelectedDocuments.filter((item) =>
            item.Type.includes('Folder')
        );
        const files = this.SelectedDocuments.filter((item) =>
            item.Type.includes('File')
        );
        this.State.IsLoading = true;
        await this.zipDownloadService.createZip(
            files,
            folders,
            this.dmsConfig.zipDownloadFileName + '_' + new Date().getTime(),
            this.dmsConfig.ModuleWorkspaceId
        );
        this.State.IsLoading = false;
    }
    delete() {
        const selectedDocs = this.SelectedDocuments.filter(
            (doc) => !ModuleDMSConfig.forbiddenIdsToDelete.includes(doc.ItemId)
        );
        if (selectedDocs.length == 0) {
            this.matSnackBarOpen("Some items can't be deleted", 1500);
            return;
        }
        this._DocumentManagerService.changeworkingState('busy');
        this._DocumentManagerService
            .RemoveMultipleArtifact(selectedDocs, this.dmsConfig.actionOnShared)
            .pipe(take(1))
            .subscribe({
                next: (resp) => {
                    console.log(resp);
                    this._DocumentManagerService.changeworkingState('idle');
                    this._DocumentManagerService.onFileRemove.next({
                        Status: true
                    });
                    this.Actions.Select('');
                }
            });
    }
    searchKey = '';
    ignoreSerchText = false;
}

export class State {
    IsLoading: boolean;
    SelectedItemIds: string[];
    ViewMode: string;
    IsDraggingOver: boolean;
    IsBottomSheetOpen: boolean;
    IsParentSecure: boolean;
    DownloadSecureFile?: boolean;
}

export class MyDrive {
    Folders: DriveFolder[];
    Files: DriveFile[];
    UploadQueue: DriveUploadQueue[];
}
